import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolusProfileChangePayload = {
  idp: number;
  modification?: number;
  bolus_status?: number;
  insulin_duration?: number;
  max_bolus_size?: number;
  bolus_entry_type?: number;
};

export type BolusProfileChangeEvent = {
  idp: number;
  modification?: number;
  bolusStatus?: number;
  insulinDuration?: number;
  maxBolusSize?: number;
  bolusEntryType?: number;
};

const bolusProfileChangeSchema = z.object({
  idp: z.number(),
  modification: cz.permissive(z.number()),
  bolus_status: cz.permissive(z.number()),
  insulin_duration: cz.permissive(z.number()),
  max_bolus_size: cz.permissive(z.number()),
  bolus_entry_type: cz.permissive(z.number()),
});

export const LID_IDP_BOLUS = {
  value: 0x46,
  name: "Personal Profile Bolus Data Change Event",
  format: "bbb.hhb.......",
  fields: ["idp", "modification", "bolus_status", "insulin_duration", "max_bolus_size", "bolus_entry_type"],
  postprocess: rec => ({
    idp: rec.idp,
    modification: rec.modification,
    bolusStatus: rec.bolus_status,
    insulinDuration: rec.insulin_duration,
    maxBolusSize: rec.max_bolus_size ? rec.max_bolus_size * 0.001 : undefined,
    bolusEntryType: rec.bolus_entry_type,
  }),
  schema: bolusProfileChangeSchema,
} as const satisfies TandemEventDefinition<BolusProfileChangePayload, BolusProfileChangeEvent>;
